const Company = ({ title }) => {
    return (
        <div className="" >
            <img className="md:opacity-60 scale-[1.1]" src={`/images/homepage/trusted/${title}.svg`} alt={title} />
        </div >
    );
};

export default Company;